import { createContext, useContext } from "react"

type ErrorModalContextType = {
  setError: (args: { error: Error; onClose?: () => void }) => void
}

export const ErrorModalContext = createContext<
  ErrorModalContextType | undefined
>(undefined)

export function useErrorModal() {
  const context = useContext(ErrorModalContext)
  if (context === undefined) {
    throw new Error("useErrorModal must be used within an ErrorModalProvider")
  }
  return context
}
